import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { IMAGES } from "@/lib/site";

const PROJECTS = [
    {
        img: IMAGES.condo,
        tag: "Condomínio · Perímetro",
        title: "Monitoramento de área comum",
        testid: "project-card-condo-residence",
    },
    {
        img: IMAGES.facialDevice,
        tag: "Portaria · Acesso facial",
        title: "Controle de acesso biométrico",
        testid: "project-card-commercial-hub",
    },
    {
        img: IMAGES.cameraPole,
        tag: "Área comum · Multi-câmeras",
        title: "Cobertura total de 360°",
        testid: "project-card-multi-camera",
    },
    {
        img: IMAGES.cameraLineup,
        tag: "Padrão de instalação",
        title: "Linha completa de equipamentos",
        testid: "project-card-equipment",
    },
];

const ProjectCard = ({ p, i }) => (
    <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: (i % 2) * 0.1 }}
        data-testid={p.testid}
        className="clip-corner group relative h-72 sm:h-80 overflow-hidden border border-white/10"
    >
        <img
            src={p.img}
            alt={p.title}
            loading="lazy"
            className="h-full w-full object-cover grayscale contrast-110 transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-ink/45 mix-blend-multiply opacity-100 group-hover:opacity-0 transition-opacity duration-500" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6">
            <span className="font-hud text-[10px] uppercase tracking-[0.25em] text-volt">
                {p.tag}
            </span>
            <h3 className="mt-2 font-display text-xl sm:text-2xl font-bold text-white">
                {p.title}
            </h3>
            <div className="mt-3 h-px w-10 bg-volt transition-all duration-500 group-hover:w-24" />
        </div>
    </motion.div>
);

const Projects = () => (
    <section id="trabalhos" className="relative py-24 lg:py-32 bg-panel/40 border-y border-white/10">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <div className="grid lg:grid-cols-12 gap-8 items-end mb-14">
                <Reveal className="lg:col-span-8">
                    <Eyebrow>[ 04 — Trabalhos ]</Eyebrow>
                    <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05] text-white">
                        Padrão de execução
                        <span className="text-mint"> em cada detalhe.</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.1} className="lg:col-span-4">
                    <p className="text-slate-400 leading-relaxed text-sm sm:text-base">
                        Imagens de referência do nível de acabamento e dos
                        equipamentos usados nas instalações.
                    </p>
                </Reveal>
            </div>

            <div
                data-testid="projects-gallery-container"
                className="grid sm:grid-cols-2 gap-5"
            >
                {PROJECTS.map((p, i) => (
                    <ProjectCard key={p.testid} p={p} i={i} />
                ))}
            </div>
        </div>
    </section>
);

export default Projects;
